// ================================================================
// AI Analysis Node — Configuration Schema
// ================================================================

export const aiAnalysisConfigSchema = {
  fields: [
    {
      key: 'model',
      type: 'select',
      labelKey: 'nodes.aiAnalysis.fields.model',
      placeholderKey: 'nodes.aiAnalysis.placeholders.model',
      required: true,
      options: [
        { value: 'gpt-4o',      labelKey: 'nodes.aiAnalysis.options.gpt4o' },
        { value: 'gpt-4o-mini', labelKey: 'nodes.aiAnalysis.options.gpt4oMini' },
        { value: 'claude',      labelKey: 'nodes.aiAnalysis.options.claude' },
        { value: 'gemini',      labelKey: 'nodes.aiAnalysis.options.gemini' },
        { value: 'swiss',       labelKey: 'nodes.aiAnalysis.options.swiss' }
      ]
    },
    {
      key: 'credentialId',
      type: 'select',
      labelKey: 'nodes.aiAnalysis.fields.credential',
      placeholderKey: 'nodes.aiAnalysis.placeholders.credential',
      required: true,
      showIf: { model: '*' },
      dynamicOptions: 'credentials',
      help: 'nodes.aiAnalysis.help.credential'
    },
    {
      key: 'swissModel',
      type: 'select',
      labelKey: 'nodes.aiAnalysis.fields.swissModel',
      placeholderKey: 'nodes.aiAnalysis.placeholders.swissModel',
      required: true,
      showIf: { model: 'swiss' },
      options: [
        { value: 'apertus',  labelKey: 'nodes.aiAnalysis.options.apertus' },
        { value: 'deepseek', labelKey: 'nodes.aiAnalysis.options.deepseek' },
        { value: 'llama',    labelKey: 'nodes.aiAnalysis.options.llama' },
        { value: 'mistral',  labelKey: 'nodes.aiAnalysis.options.mistral' },
        { value: 'gemma',    labelKey: 'nodes.aiAnalysis.options.gemma' },
        { value: 'qwen',     labelKey: 'nodes.aiAnalysis.options.qwen' }
      ]
    },
    {
      key: 'businessType',
      type: 'select',
      labelKey: 'nodes.aiAnalysis.fields.businessType',
      placeholderKey: 'nodes.aiAnalysis.placeholders.businessType',
      required: true,
      icon: 'storefront',
      dynamicOptions: 'trades'
    },
    {
      key: 'promptSource',
      type: 'select',
      labelKey: 'nodes.aiAnalysis.fields.promptSource',
      placeholderKey: 'nodes.aiAnalysis.placeholders.promptSource',
      required: true,
      showIf: { businessType: '*' },
      dynamicOptions: 'promptVersions'
    },
    {
      key: 'companyPrompts',
      type: 'repeater',
      labelKey: 'nodes.aiAnalysis.fields.companyPrompts',
      placeholderKey: 'nodes.aiAnalysis.placeholders.companyPrompts',
      addLabelKey: 'nodes.aiAnalysis.addCompanyPrompt',
      help: 'nodes.aiAnalysis.help.companyPrompts',
      showIf: { businessType: '*' }
    },
    {
      key: 'industryPrompt',
      type: 'textarea',
      labelKey: 'nodes.aiAnalysis.fields.industryPrompt',
      placeholderKey: 'nodes.aiAnalysis.placeholders.industryPrompt',
      rows: 6,
      help: 'nodes.aiAnalysis.help.industryPrompt'
    }
  ]
};
